/**
 * GapAlertBanner - Notification banner for in-stock gap alerts
 * IMPL-FEATURE2-SMARTSETS-20260204
 *
 * Shows when MDM has items matching the user's collection gaps.
 */
import React, { useState, useEffect } from 'react';
import { Bell, X, ShoppingCart, ChevronRight } from 'lucide-react';
import { getGapAlerts } from '../../services/vaultApi';

export default function GapAlertBanner({ onViewGaps }) {
  const [alerts, setAlerts] = useState([]);
  const [isDismissed, setIsDismissed] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadAlerts();
  }, []);

  const loadAlerts = async () => {
    try {
      const result = await getGapAlerts({ limit: 5 });
      setAlerts(result.alerts || []);
    } catch (error) {
      console.error('Failed to load gap alerts:', error);
    }
    setIsLoading(false);
  };

  const handleDismissAll = () => {
    setIsDismissed(true);
  };

  if (isLoading || isDismissed || alerts.length === 0) return null;

  return (
    <div className="mx-4 mt-3 p-3 bg-orange-500/10 border border-orange-500/30 rounded-lg">
      <div className="flex items-start gap-2">
        <Bell className="w-4 h-4 text-orange-400 mt-0.5 flex-shrink-0" />
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between">
            <p className="text-sm font-medium text-orange-300">
              {alerts.length} gap{alerts.length !== 1 ? 's' : ''} now in stock
            </p>
            <button
              onClick={handleDismissAll}
              className="text-zinc-500 hover:text-zinc-300 flex-shrink-0"
            >
              <X className="w-3.5 h-3.5" />
            </button>
          </div>
          <p className="text-xs text-zinc-400 mt-1">
            Issues from your want list are available at MDM.
          </p>
          <button
            onClick={onViewGaps}
            className="flex items-center gap-1 mt-2 text-xs text-orange-400 hover:text-orange-300 transition-colors"
          >
            <ShoppingCart className="w-3 h-3" />
            <span>View &amp; Shop</span>
            <ChevronRight className="w-3 h-3" />
          </button>
        </div>
      </div>
    </div>
  );
}
